import {Component, Inject} from '@angular/core';
import {OptionItem} from './classes/optionItem';
import {DOCUMENT} from '@angular/common';


function compareOptions(a: OptionItem, b: OptionItem) {
    if (a.subItems.length > 0) {
        a.subItems.sort(compareOptions);
    }
    if (a.label < b.label) {
        return -1;
    }
    if (a.label > b.label) {
        return 1;
    }
    return 0;
}

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent {
    title = 'Tw Finder';
    isIframe = false;

    constructor(@Inject(DOCUMENT) private document: Document) {
      if ((new URLSearchParams(window.location.search)).has('iframe')) {
        this.isIframe = true;

        window.addEventListener('click', (event: Event) => {
          // @ts-ignore
          const anchorElement = event.target instanceof HTMLAnchorElement ? event.target : event.target.closest('a');

          if (anchorElement) {
            event.preventDefault();

            parent.window.open(anchorElement.href, '_self');
          }
        });
      } else {
        const usercentricsScript = document.createElement('script');

        usercentricsScript.type = 'text/javascript';
        usercentricsScript.id = '4w8JW0Zl';
        usercentricsScript.src = '//app.usercentrics.eu/latest/main.js';

        document.head.appendChild(usercentricsScript);
      }
    }

    public goBack(): void {
        if ('referrer' in document) {
            if (location.protocol + '//' + location.host + location.pathname === document.referrer) {
                window.location.href = location.protocol + '//' + window.location.hostname;
            } else {
                window.location.href = document.referrer;
            }
        } else {
            window.history.back();
        }
    }

}
